import { render, staticRenderFns } from "./lyhHeader.vue?vue&type=template&id=3c98b356&scoped=true"
import script from "./lyhHeader.vue?vue&type=script&lang=js"
export * from "./lyhHeader.vue?vue&type=script&lang=js"
import style0 from "./lyhHeader.vue?vue&type=style&index=0&id=3c98b356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98b356",
  null
  
)

export default component.exports